<template>
  <div class="lab-staff">
    <div class="page-title-set">
      <h3 class="page-title">
        社員紹介<br>
        <KurehaArrow class="kureha_arrow" :width="270" />
      </h3>
      <p class="page-catch">
          研究・技術職種
        </p>
    </div>
    <div class="staff-entrance">
      <swiper :options="swiperOption">
        <swiper-slide>
          <section class="stafflink">
            <router-link to="/newgraduate/lab/staff/01/">
              <img src="../../assets/img/lab/staff/entrance/01.png" alt="01 TAKENORI TOSE">
            </router-link>
          </section>
        </swiper-slide>
        <swiper-slide>
          <section class="stafflink">
            <router-link to="/newgraduate/lab/staff/02/">
              <img src="../../assets/img/lab/staff/entrance/02.png" alt="02 YINGGE XIAO">
            </router-link>
          </section>
        </swiper-slide>
        <swiper-slide>
          <section class="stafflink">
            <router-link to="/newgraduate/lab/staff/03/">
              <img src="../../assets/img/lab/staff/entrance/03.png" alt="03 RISA TAKAHASHI">
            </router-link>
          </section>
        </swiper-slide>
        <swiper-slide>
          <section class="stafflink">
            <router-link to="/newgraduate/lab/staff/04/">
              <img src="../../assets/img/lab/staff/entrance/04.png" alt="04 MAKOTO IMAJI">
            </router-link>
          </section>
        </swiper-slide>
        <swiper-slide>
          <section class="stafflink">
            <router-link to="/newgraduate/lab/staff/05/">
              <img src="../../assets/img/lab/staff/entrance/05.png" alt="05 HIKARU KOBAYASHI">
            </router-link>
          </section>
        </swiper-slide>
        <swiper-slide>
          <section class="stafflink">
            <router-link to="/newgraduate/lab/staff/06/">
              <img src="../../assets/img/lab/staff/entrance/06.png" alt="06 AYA SHIKE">
            </router-link>
          </section>
        </swiper-slide>
        <swiper-slide>
          <section class="stafflink">
            <router-link to="/newgraduate/lab/staff/07">
              <img src="../../assets/img/lab/staff/entrance/07.png" alt="07 YUKITARO SAKAKIBARA">
            </router-link>
          </section>
        </swiper-slide>
<!--        <swiper-slide>-->
<!--          <section class="stafflink">-->
<!--            <router-link to="/newgraduate/lab/staff/08/">-->
<!--              <img src="../../assets/img/lab/staff/entrance/08.png" alt="08 KENTA USHIRO">-->
<!--            </router-link>-->
<!--          </section>-->
<!--        </swiper-slide>-->
        <div class="swiper-mybutton-prev" slot="button-prev">
          <img src="../../assets/img/lab/staff/entrance/nav_prev.png" alt="prev">
        </div>
        <div class="swiper-mybutton-next" slot="button-next">
          <img src="../../assets/img/lab/staff/entrance/nav_next.png" alt="next">
        </div>
      </swiper>

        <div class="swiper-mypagination">
        </div>
    </div>
  </div>
</template>

<script>
import KurehaArrow from "@/components/icons/KurehaArrow.vue"
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'staff',
  components: {
    KurehaArrow,
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        cssMode: true,
        slidesPerView: 4,
        breakpoints: {
          // when window width is >= 768px
          1000: {
            slidesPerView: 2,
            spaceBetween: 0
          }
        },
        // setWrapperSize: true,
        spaceBetween: 0,
        // width: 1000,
        // updateOnWindowResize: false,
        navigation: {
          nextEl: '.swiper-mybutton-next',
          prevEl: '.swiper-mybutton-prev'
        },
        pagination: {
          el: '.swiper-mypagination',
          clickable: true,
        },
        autoplay: {
          delay: 3000,
        },
      },
    }
  },
  mounted() {
    // var mySwiper = new Swiper('.swiper-container', {
    //     speed: 400,
    //     spaceBetween: 100
    // });
    // var mySwiper = document.querySelector('.swiper-container').swiper
    // Now you can use all slider methods like
    // mySwiper.slideNext();
    // mySwiper.autoplay.start();
  }
}
</script>

<style scoped lang="scss">
.lab-staff {
  background-image: radial-gradient(circle at 40% 120%, #3fae00 -20%, transparent 40% ),radial-gradient(circle at 70% 130%, #3fae00 -20%, transparent 40% ),radial-gradient(circle at top right, #3fae00 -40%, transparent 40% );
  background-size: 100%;
  background-color: #00797f;
  padding: 100px 0 200px 0;
  @media print, screen and (max-width: 900px) {
    padding: 50px 0 80px 0;
  }
  &:before {
    content: "";
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    background-image: linear-gradient(#cccccc54 1px, transparent 0),
                    linear-gradient(90deg, #cccccc54 1px, transparent 0);
    background-size: 10px 10px;
    z-index: 0;
  }
}
// .page-title {
//   color: #fff;
//   letter-spacing: 0.1em;
//   position: relative;
//   font-size: 42px;
//   text-align: center;
//   line-height: 1;
//   @media print, screen and (max-width: 900px) {
//     font-size: 20px;
//   }
//   i {
//     font-size: 20px;
//     display: block;
//     @media print, screen and (max-width: 900px) {
//       font-size: 16px;
//     }
//   }
//   .kureha_arrow {
//     position: relative;
//     width: 300px;
//     bottom: 5px;
//     margin-bottom: 0;
//     @media print, screen and (max-width: 900px) {
//       width: 200px;
//       bottom: 0px;
//     }
//   }
// }
.page-title-set {
  margin: 0 auto;
  text-align: center;
  width: 90%;
  letter-spacing: 0.1em;
}
.page-title {
  letter-spacing: 0.2em;
  line-height: 1em;
  display: inline-block;
  color: #fff;
  font-size: 42px;
  text-align: center;
  margin-bottom: 0.5em;
  display: inline-block;
  width: auto;
  position: relative;
  @media print, screen and (max-width: 414px) {
    font-size: 22px;
  }
}
.page-catch {
  font-size: 20px;
  line-height: 2em;
  color: #fff;
  text-align: center;
  font-weight: bold;
  margin: 0;
  margin-top: 1em;
  @media print, screen and (max-width: 414px) {
    font-size: 14px;
  }
}
.kureha_arrow {
  position: absolute;
  display: block;
  width: auto;
  bottom: -50%;
}
.staff-entrance {
  margin: 0 auto;
  margin-top: 100px;
  position: relative;
  width: 100%;
  @media print, screen and (max-width: 414px) {
    margin-top: 50px;
  }
}
.stafflink {
  max-width: 330px;
  width: 100%;
  display: inline-block;
  transition: transform 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);
  &:hover {
    transform: scale(1.02);
  }
}
.swiper-mybutton-prev {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  cursor: pointer;
  img {
    width: 64px;
  }
}
.swiper-mybutton-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  z-index: 1;
  cursor: pointer;
  img {
    width: 64px;
  }
}
.swiper-mypagination {
  bottom: -50px;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
::v-deep .swiper-pagination-bullet {
  opacity: 1;
  background-color: #333;
  margin: 0 5px;
  width: 15px;
  height: 15px;
}
::v-deep .swiper-pagination-bullet-active {
  background: #fff!important;
}
</style>
